// The token endpoint lives in .env (REACT_APP_TOKEN_ENDPOINT) and is baked into the build.
export const getTokenEndpoint = () => {
  const endpoint = process.env.REACT_APP_TOKEN_ENDPOINT;

  if (!endpoint) {
    throw new Error('No token endpoint is configured. Set REACT_APP_TOKEN_ENDPOINT in .env.');
  }
  return endpoint;
};
